import { Fragment, type ReactNode } from 'react';

export type Figure = { label: ReactNode; value: ReactNode; key?: string };

/** Labelled values stacked in a cell: label on the left, figure on the right. */
export function Figures({ rows }: { rows: Figure[] }) {
  return (
    <dl className="sk:m-0 sk:grid sk:grid-cols-[auto_1fr] sk:gap-x-3 sk:gap-y-0.5 sk:text-dense">
      {rows.map((row, index) => (
        <Fragment
          key={row.key ?? (typeof row.label === 'string' ? row.label : index)}
        >
          <dt className="sk:whitespace-nowrap sk:text-fg-secondary">
            {row.label}
          </dt>
          <dd className="sk:m-0 sk:whitespace-nowrap sk:text-right sk:tabular-nums">
            {row.value}
          </dd>
        </Fragment>
      ))}
    </dl>
  );
}
